import { Stack, Typography } from '@mui/material';
import { LevelChip } from '@retail/calculus/components';
import { useCalculusTFunction } from '@retail/calculus/i18n';
import { HierarchyLevels } from '@retail/products/types';
import { getLLDate } from '@retail/utils';
import { InfinityIcon } from '@shared/custom-icons';

interface Props {
  bindingType: HierarchyLevels;
  conditionValueDesc?: string;
  conditionValue?: React.ReactNode;
  separateValueLine?: boolean;
  validFrom: Date;
  validTo?: Date;
}

export function CalculusAreaAccordionDetails({
  bindingType,
  conditionValue,
  conditionValueDesc,
  separateValueLine,
  validFrom,
  validTo,
}: Props) {
  const t = useCalculusTFunction();
  return (
    <Stack px={2} gap={1.5} flexDirection="column">
      <Stack
        display={separateValueLine ? 'flex' : 'grid'}
        gap={separateValueLine ? 2 : undefined}
        gridTemplateColumns="1.2fr 1fr"
      >
        <Stack flexDirection="row" gap={2} alignItems="center">
          <Typography variant="body2">{t('calculus.level.level')}</Typography>
          {<LevelChip active height={26} bindingType={bindingType} />}
        </Stack>
        <Stack flexDirection="row" gap={2} alignItems="center">
          <Typography whiteSpace="nowrap" variant="body2">
            {conditionValueDesc}
          </Typography>
          {conditionValue}
        </Stack>
      </Stack>

      <Stack display="grid" gridTemplateColumns="1.2fr 1fr">
        <Stack flexDirection="row" gap={2} alignItems="center">
          <Typography variant="body2">{t('calculus.activeFrom')}</Typography>
          <Typography variant="subtitle2">{getLLDate(validFrom)}</Typography>
        </Stack>

        <Stack flexDirection="row" gap={2} alignItems="center">
          <Typography variant="body2">{t('calculus.activeTo')}</Typography>
          {getLLDate(validTo) ? (
            <Typography variant="subtitle2">{getLLDate(validTo)}</Typography>
          ) : (
            <InfinityIcon fontSize="small" />
          )}
        </Stack>
      </Stack>
    </Stack>
  );
}
